import { render, staticRenderFns } from "./SaReports.vue?vue&type=template&id=b0230130"
import script from "./SaReports.vue?vue&type=script&lang=js"
export * from "./SaReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports